<app-empty-table *ngIf="!drafts?.length" class="container-box">
  <img class="empty-image" src="assets/images/empty_icons/automation-draft-task.svg" />
  <h5 class="empty-header" i18n>No Automation based Incidents yet for Task Approval</h5>
  <p i18n>Task that requires PM review & approval after manual incident creation will appear here</p>
</app-empty-table>

<ng-container *ngFor="let task of drafts">
  <div class="container-box d-flex gap-3 p-3">
    <div
      class="bg-secondary-danger text-danger rounded-circle d-flex align-items-center justify-content-center"
      style="width: 50px; height: 50px"
    >
      <i class="cs-icon cs-icon-building-incident text-4xl"></i>
    </div>
    <div class="flex-fill">
      <ul class="dot-segments-list">
        <li class="text-bold">
          {{ task.name }}
        </li>
        <li class="text-light">
          {{ task.created | epoch : 'datetime' }}
        </li>
      </ul>
      <div class="bg-default p-2 rounded mt-2">
        {{ task.notes }}
      </div>
    </div>
  </div>
  <div class="d-flex flex-wrap align-items-center gap-3 mt-2 mb-3">
    <div class="flex-fill"></div>
    <button class="btn btn-secondary-info btn-sm" (click)="onViewTask(task)" *ngIf="!task.draft">
      <i class="cs-icon cs-icon-eye"></i>
      <ng-container i18n>View Task</ng-container>
    </button>
    <ng-container *ngIf="task.draft">
      <button class="btn btn-secondary-danger btn-sm" (click)="onRejectTask(task)">
        <i class="cs-icon cs-icon-times"></i>
        <ng-container i18n>Reject</ng-container>
      </button>
      <button class="btn btn-secondary-success btn-sm" (click)="onApproveTask(task)">
        <i class="cs-icon cs-icon-check"></i>
        <ng-container i18n>Approve & Create Task</ng-container>
      </button>
    </ng-container>
  </div>
</ng-container>
